import {
    checkboxColDefCreator,
    dateColDefCreator,
    datetimeColDefCreator,
    employeeColDefCreator,
    modifyButtonColDefCreator,
    rowCountColDefCreator,
    stringColDefCreator,
} from "./standard-col-def-creators"
import { tContext } from "../types"

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getRateTablesSettings = () => {
    return {
        tableName: "Rate Tables",
        navId: "rateTables",
        resources: ["rateTables"],
        relatedNames: {
            rateTables: {
                employees: ["/created_by_id"],
            },
        },
        filters: [],
        colDefs: [
            checkboxColDefCreator({
                width: 60,
                headerCheckboxSelection: true,
                pinned: "left",
            }),
            stringColDefCreator({
                headerName: "Name",
                maxLength: 100,
                width: 225,
                field: "/name",
                pinned: "left",
            }),
            stringColDefCreator({
                headerName: "Description",
                maxLength: 100,
                width: 225,
                field: "/description",
            }),
            dateColDefCreator({
                headerName: "Start Date",
                field: "/start_date",
                width: 130,
                extraParams: { clearable: true },
            }),
            dateColDefCreator({
                headerName: "End Date",
                field: "/end_date",
                width: 130,
                extraParams: { clearable: true },
            }),
            rowCountColDefCreator({
                headerName: "Labor Rates",
                field: "/labor_rates",
                editable: false,
                width: 120,
            }),
            rowCountColDefCreator({
                headerName: "Equipment Rates",
                field: "/equipment_rates",
                editable: false,
                width: 120,
            }),
            rowCountColDefCreator({
                headerName: "Material Rates",
                field: "/material_rates",
                editable: false,
                width: 120,
            }),
            datetimeColDefCreator({
                headerName: "Last Updated",
                field: "/last_updated",
                editable: false,
                width: 220,
            }),
            datetimeColDefCreator({
                headerName: "Created On",
                field: "/created_on",
                editable: false,
                width: 220,
            }),
            employeeColDefCreator({
                headerName: "Created By",
                field: "/created_by_id",
                width: 150,
                editable: false,
            }),
            {
                ...modifyButtonColDefCreator({
                    modifyFlow: "RATE_TABLES_MODIFY",
                    headerName: "Settings",
                }),
                field: "/settings",
                // Prevent AG-Grid from intercepting clicks meant for the Modify button
                editable: false,
                excludeFromExport: true,
            },
        ],
        gridSettings: {
            rowHeight: 40,
            defaultColDef: {
                editable: true,
                filter: true,
                sortable: true,
            },
            rowSelection: "multiple",
        },
        otherSettings: {
            hiddenColumnDefaults: {
                sort_order: {
                    value: 0,
                },
            },
            buttons: {
                cell: [],
                row: [
                    {
                        label: "Duplicate",
                        icon: "copy",
                        action: "duplicateRateTables",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        disabled: (context: tContext) => context.currentUser.employee.user_role !== "ADMIN",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        tooltip: (context: tContext) =>
                            context.currentUser.employee.user_role !== "ADMIN"
                                ? "Only Admins can perform this operation"
                                : "Duplicate the selected rate tables",
                    },
                    {
                        label: "Delete",
                        icon: "delete",
                        action: "deleteSelectedRows",
                        showWarningModal: true,
                        modalTitle: "Delete Rate Tables",
                        modalDescription: "Are you sure you want to delete the selected rate tables?",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        disabled: (context: tContext) => context.currentUser.employee.user_role !== "ADMIN",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        tooltip: (context: tContext) =>
                            context.currentUser.employee.user_role !== "ADMIN"
                                ? "Only Admins can perform this operation"
                                : "Delete the selected rate tables",
                    },
                ],
                table: [
                    {
                        label: "Create",
                        icon: "add",
                        action: "addNewRow",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        disabled: (context: tContext) => context.currentUser.employee.user_role !== "ADMIN",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        tooltip: (context: tContext) =>
                            context.currentUser.employee.user_role !== "ADMIN"
                                ? "Only Admins can perform this operation"
                                : "Create a new rate table",
                    },
                ],
            },
        },
    }
}
